'use client'

import { type FC } from 'react'

import { useStoryblokStory } from '../../context/StoryblokStoryContext'
import { type StoryblokComponentProps } from '../../model'
import { type StoryblokProductSearchType } from '../../storyblok'
import { StoryblokCategoryProductSearch } from '../StoryblokAkeneoCategoryPage'
import { StoryblokBrandProductSearch } from '../StoryblokBrandPage/components/StoryblokBrandProductSearch'

export const StoryblokProductSearch: FC<
  StoryblokComponentProps<StoryblokProductSearchType>
> = () => {
  const story = useStoryblokStory()

  if (story.content.component === 'BrandPage') {
    return <StoryblokBrandProductSearch />
  }

  if (story.content.component === 'AkeneoCategoryPage') {
    return <StoryblokCategoryProductSearch />
  }

  return null
}
